<template>
  <div id="index">
    <el-container>
      <el-main>
        <img
          src="~assets/img/splash_logo.png"
          style="
            width: 475px;
            height: 203px;
            position: absolute;
            top: 150px;
            left: 124px;
          "
        />

        <el-button
          style="position: absolute; top: 400px; left: 124px"
          @click="ssoSkip()"
          >{{ $t("desc.useIRAccountLogin") }}
          <!-- <i
            class="el-icon-arrow-right el-icon--right"
            style="vertical-align: text-bottom; font-weight: bold"
          ></i
        > -->
        </el-button>

        <el-row :gutter="24" style="margin: 0px !important">
          <el-col :xs="0" :sm="0" :md="12" :lg="12">
            <img
              v-if="brand == 'IR'"
              src="~assets/img/Loginlogo.png"
              class="loginIcon"
            />
            <img
              v-if="brand == 'GD'"
              src="~assets/img/GDlogo.png"
              class="loginIcon"
            />
          </el-col>
        </el-row>
        <!-- <div class="loginRecordBox">
          <el-link href="https://www.irconnectivity.com" target="_blank"
            >备案主体：英格索兰（中国）投资有限公司</el-link
          >
          <el-link href="https://www.beian.miit.gov.cn" target="_blank"
            >备案号：沪ICP备05062828号-5</el-link
          >
          <el-link
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005741"
            target="_blank"
            ><img
              src="~assets/img/recordicon.png"
              style="float: left; width: 16px"
            />沪公网安备 31010502005741号
          </el-link>
        </div> -->
      </el-main>
    </el-container>
  </div>
</template>
  
  <script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { getSamlRequestUrl } from "../../api/api";
import { setCookie, getCookie } from "../../../utils/package-cookies";
import {
  setItemToLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage";
import router from "../../../src/router/index";
import defaultSettings from "@/config/defaultSettings";

export default {
  name: "Index",
  data() {
    return {
      // 对话框显示和隐藏
      dialogVisible: false,
      form: {
        userNameOrEmailAddress: "",
        password: "",
        clientName: this.$route.path,
      },
      brand: "IR",
    };
  },
  created: function () {
    //this.ssoSkip()
  },
  async mounted() {},
  computed: {
    // ...mapGetters({
    //   menuListStore: "menuListState",
    //   authOperationStore: "authOperationState",
    // }),
  },
  methods: {
    ssoSkip() {
      this.brand = Globals.VUE_APP_Brand;
      let hash = window.location.href;
      let para_brand = "ir";
      let page = "";
      let dsn = "";
      if (
        hash.indexOf("testgdweb.irconnectivity.com") >= 0 ||
        hash.indexOf("gdiconn.irconnectivity.com/") >= 0 ||
        hash.indexOf("gdapiconn.irconnectivity.com/") >= 0
      ) {
        para_brand = "gd";
      }
      if (hash != "" && hash.indexOf("?") >= 0) {
        let str = hash.split("?")[1];
        var paras = str.split("&");
        paras.forEach(function (o, i) {
          var subArr = o.split("=");
          if (subArr[0] == "brand") {
            if (subArr[1] != "") {
              para_brand = decodeURIComponent(subArr[1]);
            }
          } else if (subArr[0] == "page") {
            page = decodeURIComponent(subArr[1]);
          } else if (subArr[0] == "dsn") {
            dsn = decodeURIComponent(subArr[1]);
          }
        });
      }
      this.getSamlRequestUrl(para_brand, page, dsn);
    },
    getSamlRequestUrl(brand, page, dsn) {
      getSamlRequestUrl(brand, page, dsn).then((res) => {
        var samlUrl = res.result;
        window.location.href = samlUrl;
      });
    },
  },
};
</script>

<style lang='less'>
.theme1 {
  .el-main {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url("~assets/img/splash.jpg");
    background-position: left top;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .el-main {
    padding: 20px 7%;
    width: 100%;
  }
}
</style>